module.exports = __webpack_public_path__ + "static/img/052_TO8_1587.8673940.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/052_TO8_1587.jpg
// module id = I+It
// module chunks = 0